import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { Box, ChakraProvider, Flex } from '@chakra-ui/react';
import { Provider } from 'react-redux';
import { MemoryRouter, Route, Routes } from 'react-router-dom';
import Header from './Components/Header';
import { Store } from './Store/StoreInit';
import HomePg from './Components/HomePg';
import HealthPlanMappingNav from './Components/HealthPlanMappingNav';
import PayerForms from './PayerForms/PayerForms';
import React, { useEffect, useState } from 'react';
import AppInit from './Components/AppInit';
import InventoryNav from './Components/InventoryNav';
import PayerFormsVariations from './PayerForms/PayerFormsVariations';
import Scenarios from './Scenarios/Scenarios';
import RRDInventoryPage from './RRDInventory/RRDInventoryPage';
import RRDInventoryNav from './Components/RRDInventoryNav';

const appVersion = '2.0.1';

export function App() {
  const isAuthenticated = useIsAuthenticated();
  const [tabIndex, setTabIndex] = React.useState(0);
  const [document, setDocument] = React.useState(0);

  return (
    <>
      <Provider store={Store}>
        <AppInit />
        {/* <ChakraProvider> */}
          <MemoryRouter>
            <Flex
              bg="white"
              h="100vh"
              w="100vw"
              color="black"
              display="flex"
              flexDirection="column"
            >
              <Header />

              <Box flex="1" overflow="auto">
                <Routes>
                  <Route
                    path="/"
                    element={<HomePg setTabIndex={setTabIndex} />}
                  />
                  {isAuthenticated && (
                    <>
                      <Route
                        path="/HealthPlan"
                        element={
                          <HealthPlanMappingNav setTabIndex={setTabIndex} />
                        }
                      />
                      <Route
                        path="/Inventory"
                        element={<InventoryNav setTabIndex={setTabIndex} />}
                      />
                      <Route
                        path="/RRDInventory"
                        element={
                          // <Harmony appId="OPTUM_APP_ID" licenseKey="evaluation-license-key">
                            <RRDInventoryNav  setTabIndex={setTabIndex} />
                          // </Harmony> 
                        }
                      />
                      <Route
                        path="/Scenarios"
                        element={<Scenarios setTabIndex={setTabIndex} />}
                      />
                      <Route
                        path="/PayerForms"
                        element={
                          tabIndex === 0 ? (
                            <PayerForms
                              setTabIndex={setTabIndex}
                              setDocument={setDocument}
                            />
                          ) : (
                            <PayerFormsVariations
                              document={document}
                              setTabIndex={setTabIndex}
                            />
                          )
                        }
                      />
                    </>
                  )}
                </Routes>
              </Box>

              <Box
                as="footer"
                bg="#fbf9f4"
                borderTop="1px solid #d9d4c9"
                color="#002677"
                px={6}
                py={3}
                textAlign="left"
                fontSize="sm"
              >
                Version {appVersion}
              </Box>
            </Flex>
          </MemoryRouter>
          {/* </ChakraProvider> */}
      </Provider>
    </>
    // <>
    //   <Provider store={Store}>
    //     <AppInit />
    //     <MemoryRouter>
    //       <Flex
    //         bg="white"
    //         h="100vh"
    //         w="100vw"
    //         color="black"
    //         display="flex"
    //         flexDirection="column"
    //       >
    //         <Header />

    //         <Box>
    //           <Routes>
    //             {accessibleRoutes.map((route, index) => (
    //               <Route key={index} path={route.path} element={route.component} />
    //             ))}
    //           </Routes>
    //         </Box>
    //       </Flex>
    //     </MemoryRouter>
    //   </Provider>
    // </>
  );
}
